import endpoints from 'config/endpoints';

import {getAccountColor} from 'modules/store/accounts';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import {TIMEOUT_STORE, DEFAULT_ARRAY, IS_EMPTY, TIMESTAMP_MULTIPLY} from 'util/constants';

const
    createFetchParams = (page, selectedAccount, ticketId) => ({
        page,
        account: selectedAccount,
        id:      ticketId
    }),
    transformEntitiesFn = ticket => ({
        idTicket:         ticket.case_id,
        created:          ticket.created * TIMESTAMP_MULTIPLY,
        author:           ticket.submitted_by,
        attachmentsCount: ticket.attachments ? ticket.attachments.length : IS_EMPTY,
        attachments:      ticket.attachments ? ticket.attachments.map(item => ({
            id:   item.id,
            name: item.file_name
        })) : DEFAULT_ARRAY,
        accountId:    ticket.account.id,
        accountName:  ticket.account.name,
        accountColor: getAccountColor(ticket.account.name),
        description:  ticket.body
    }),
    transformEntitiesToSaveFn = ticket => ({
        body:        ticket.comment,
        attachments: ticket.attachments.map(item => ({
            file_name: item.name,
            hash:      item.hash
        }))
    });

const exports = storeModuleFactory({
    name:             'awsSupportComments',
    endpoint:         endpoints.awsSupport.comments.endpoint,
    instanceEndpoint: endpoints.awsSupport.comments.instanceEndpoint,
    timeout:          TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.createFetchParams = createFetchParams;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsSupportComments.js